export default __webpack_public_path__ + "static/media/menunew.a1def827.svg";